import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import About from "./views/About.vue";
import Id from "./views/Id.vue";
import User from "./views/User.vue";
import Users from "./views/Users.vue";
import Card from "./views/Card.vue";
import Tag from "./views/Tag.vue";

Vue.use(Router);


export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/about",
      name: "about",
      component: About
    },
    {
      path: "/id",
      name: "id",
      component: Id
    },
    {
      path: "/reset_password",
      // name: "reset_password",
      component: Home,
      props: (route) => ({ showPasswordReset: true, resetPasswordToken: route.query.reset_password_token })
    },
    {
      path: '/users',
      component: Users,
      name: 'users',
    },
    {
      path: '/users/:id',
      component: User,
      name: 'user',
      props: function (route) { return { id: Number(route.params.id) }; }
    },
    {
      path: '/cards/:id',
      component: Card,
      name: 'card',
      props: function (route) { return { id: Number(route.params.id) }; }
    },
    {
      path: '/tags/:id',
      component: Tag,
      name: 'tag',
      props: function (route) { return { id: Number(route.params.id) }; }
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (to.name == 'card') {
      return document.getElementById('Menu').scrollIntoView();
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 }
    }
  }
});
